// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_onboarding_page{
  background:#fff;
  padding:22px;
  border-radius:20px;
  border:1px solid #edf2f7;
  box-shadow:0 6px 20px rgba(15,23,42,.05);
}

.e2e_onboarding_top{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:24px;
}

.e2e_onboarding_top h2{
  margin:0;
  font-size:24px;
  font-weight:800;
  color:#0f172a;
}

.e2e_onboarding_heading_line{
  width:100px;
  height:4px;
  margin-top:10px;
  border-radius:20px;
  background:linear-gradient(90deg,#2563eb,#7c3aed);
}

.e2e_onboarding_add_btn{
  border:none;
  height:42px;
  padding:0 22px;
  border-radius:12px;
  color:white;
  font-weight:700;
  cursor:pointer;
  background:linear-gradient(135deg,#1677ff,#2563eb);
}

.e2e_onboarding_filters{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:18px;
  border-radius:16px;
  background:#f8fafc;
  border:1px solid #edf2f7;
  margin-bottom:18px;
}

.e2e_onboarding_filter_left{
  display:flex;
  align-items:center;
  gap:12px;
}

.e2e_onboarding_select{
  height:40px;
  min-width:200px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 12px;
}

.e2e_onboarding_report_btn{
  height:40px;
  border:none;
  padding:0 18px;
  border-radius:10px;
  color:white;
  font-weight:700;
  cursor:pointer;
  background:linear-gradient(135deg,#06b6d4,#0891b2);
}

.e2e_onboarding_search{
  width:260px;
  height:40px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 14px;
}

.e2e_onboarding_show_row{
  margin-bottom:15px;
}

.e2e_onboarding_entries{
  height:36px;
  margin:0 10px;
  border:1px solid #dbe2ea;
  border-radius:8px;
}

.e2e_onboarding_table_wrapper{
  overflow-x:auto;
}

.e2e_onboarding_table{
  width:100%;
  border-collapse:separate;
  border-spacing:0 10px;
}

.e2e_onboarding_head_row th{
  background:#f8fafc;
  padding:15px;
  font-size:12px;
  font-weight:800;
  text-transform:uppercase;
  color:#64748b;
  border-top:1px solid #e2e8f0;
  border-bottom:1px solid #e2e8f0;
}

.e2e_onboarding_row{
  background:#fff;
  box-shadow:0 3px 12px rgba(15,23,42,.05);
}

.e2e_onboarding_row td{
  padding:18px 16px;
  border-top:1px solid #f1f5f9;
  border-bottom:1px solid #f1f5f9;
  text-align:center;
}

.e2e_onboarding_td_candidate{
  text-align:left;
}

.e2e_onboarding_details{
  display:flex;
  flex-direction:column;
  gap:6px;
}

.e2e_onboarding_details p{
  margin:0;
  color:#475569;
}

.e2e_onboarding_details strong{
  color:#0f172a;
  margin-left:5px;
}

.e2e_onboarding_status_completed{
  background:#dcfce7;
  color:#15803d;
  padding:6px 12px;
  border-radius:20px;
  font-size:12px;
  font-weight:700;
}

.e2e_onboarding_status_pending{
  background:#fee2e2;
  color:#dc2626;
  padding:6px 12px;
  border-radius:20px;
  font-size:12px;
  font-weight:700;
}

.e2e_onboarding_status_progress{
  background:#dbeafe;
  color:#2563eb;
  padding:6px 12px;
  border-radius:20px;
  font-size:12px;
  font-weight:700;
}

.e2e_onboarding_actions{
  display:flex;
  justify-content:center;
  gap:8px;
}

.e2e_onboarding_view_btn,
.e2e_onboarding_edit_btn,
.e2e_onboarding_delete_btn{
  border:none;
  min-width:65px;
  height:32px;
  border-radius:8px;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}

.e2e_onboarding_view_btn{
  background:#dbeafe;
  color:#2563eb;
}

.e2e_onboarding_edit_btn{
  background:#fef3c7;
  color:#d97706;
}

.e2e_onboarding_delete_btn{
  background:#fee2e2;
  color:#dc2626;
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/candidateonboarding.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;AACT;;AAEA;;;EAGE,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".e2e_onboarding_page{\r\n  background:#fff;\r\n  padding:22px;\r\n  border-radius:20px;\r\n  border:1px solid #edf2f7;\r\n  box-shadow:0 6px 20px rgba(15,23,42,.05);\r\n}\r\n\r\n.e2e_onboarding_top{\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  margin-bottom:24px;\r\n}\r\n\r\n.e2e_onboarding_top h2{\r\n  margin:0;\r\n  font-size:24px;\r\n  font-weight:800;\r\n  color:#0f172a;\r\n}\r\n\r\n.e2e_onboarding_heading_line{\r\n  width:100px;\r\n  height:4px;\r\n  margin-top:10px;\r\n  border-radius:20px;\r\n  background:linear-gradient(90deg,#2563eb,#7c3aed);\r\n}\r\n\r\n.e2e_onboarding_add_btn{\r\n  border:none;\r\n  height:42px;\r\n  padding:0 22px;\r\n  border-radius:12px;\r\n  color:white;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n  background:linear-gradient(135deg,#1677ff,#2563eb);\r\n}\r\n\r\n.e2e_onboarding_filters{\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  padding:18px;\r\n  border-radius:16px;\r\n  background:#f8fafc;\r\n  border:1px solid #edf2f7;\r\n  margin-bottom:18px;\r\n}\r\n\r\n.e2e_onboarding_filter_left{\r\n  display:flex;\r\n  align-items:center;\r\n  gap:12px;\r\n}\r\n\r\n.e2e_onboarding_select{\r\n  height:40px;\r\n  min-width:200px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:10px;\r\n  padding:0 12px;\r\n}\r\n\r\n.e2e_onboarding_report_btn{\r\n  height:40px;\r\n  border:none;\r\n  padding:0 18px;\r\n  border-radius:10px;\r\n  color:white;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n  background:linear-gradient(135deg,#06b6d4,#0891b2);\r\n}\r\n\r\n.e2e_onboarding_search{\r\n  width:260px;\r\n  height:40px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:10px;\r\n  padding:0 14px;\r\n}\r\n\r\n.e2e_onboarding_show_row{\r\n  margin-bottom:15px;\r\n}\r\n\r\n.e2e_onboarding_entries{\r\n  height:36px;\r\n  margin:0 10px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:8px;\r\n}\r\n\r\n.e2e_onboarding_table_wrapper{\r\n  overflow-x:auto;\r\n}\r\n\r\n.e2e_onboarding_table{\r\n  width:100%;\r\n  border-collapse:separate;\r\n  border-spacing:0 10px;\r\n}\r\n\r\n.e2e_onboarding_head_row th{\r\n  background:#f8fafc;\r\n  padding:15px;\r\n  font-size:12px;\r\n  font-weight:800;\r\n  text-transform:uppercase;\r\n  color:#64748b;\r\n  border-top:1px solid #e2e8f0;\r\n  border-bottom:1px solid #e2e8f0;\r\n}\r\n\r\n.e2e_onboarding_row{\r\n  background:#fff;\r\n  box-shadow:0 3px 12px rgba(15,23,42,.05);\r\n}\r\n\r\n.e2e_onboarding_row td{\r\n  padding:18px 16px;\r\n  border-top:1px solid #f1f5f9;\r\n  border-bottom:1px solid #f1f5f9;\r\n  text-align:center;\r\n}\r\n\r\n.e2e_onboarding_td_candidate{\r\n  text-align:left;\r\n}\r\n\r\n.e2e_onboarding_details{\r\n  display:flex;\r\n  flex-direction:column;\r\n  gap:6px;\r\n}\r\n\r\n.e2e_onboarding_details p{\r\n  margin:0;\r\n  color:#475569;\r\n}\r\n\r\n.e2e_onboarding_details strong{\r\n  color:#0f172a;\r\n  margin-left:5px;\r\n}\r\n\r\n.e2e_onboarding_status_completed{\r\n  background:#dcfce7;\r\n  color:#15803d;\r\n  padding:6px 12px;\r\n  border-radius:20px;\r\n  font-size:12px;\r\n  font-weight:700;\r\n}\r\n\r\n.e2e_onboarding_status_pending{\r\n  background:#fee2e2;\r\n  color:#dc2626;\r\n  padding:6px 12px;\r\n  border-radius:20px;\r\n  font-size:12px;\r\n  font-weight:700;\r\n}\r\n\r\n.e2e_onboarding_status_progress{\r\n  background:#dbeafe;\r\n  color:#2563eb;\r\n  padding:6px 12px;\r\n  border-radius:20px;\r\n  font-size:12px;\r\n  font-weight:700;\r\n}\r\n\r\n.e2e_onboarding_actions{\r\n  display:flex;\r\n  justify-content:center;\r\n  gap:8px;\r\n}\r\n\r\n.e2e_onboarding_view_btn,\r\n.e2e_onboarding_edit_btn,\r\n.e2e_onboarding_delete_btn{\r\n  border:none;\r\n  min-width:65px;\r\n  height:32px;\r\n  border-radius:8px;\r\n  font-size:11px;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n}\r\n\r\n.e2e_onboarding_view_btn{\r\n  background:#dbeafe;\r\n  color:#2563eb;\r\n}\r\n\r\n.e2e_onboarding_edit_btn{\r\n  background:#fef3c7;\r\n  color:#d97706;\r\n}\r\n\r\n.e2e_onboarding_delete_btn{\r\n  background:#fee2e2;\r\n  color:#dc2626;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
